import styled from 'styled-components';
import whiteCheckMark from 'assets/images/check-mark-white.svg';

const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border: 1px solid ${p => p.theme.color.border};
  border-radius: 6px;
  text-align: left;
  margin-top: 1em;
  overflow: hidden;
  table-layout: fixed;
  thead {
    background-color: ${p => p.theme.color.background};
  }
  th {
    font-weight: normal;
    max-width: 160px;
    font-size: 14px;
    border-collapse: collapse;
    color: ${props => props.theme.color.label};      
    border-right: 1px solid ${p => p.theme.color.border};
    height: 50px;
    &.time {
      text-align: center; 
    }
  }
  td {
    height: 60px;      
    border-right: 1px solid ${p => p.theme.color.border};
    border-top: 1px solid ${p => p.theme.color.border};
    &.time {
      padding: 0;     
    }
    &:hover:not(:first-of-type){
      cursor: pointer;
    }
  }
  td, th {
    padding: 5px 16px;
    box-sizing: border-box;
    &:last-child {
      border-right: none;
    }   
  }
  .triggers {
    text-align: center;
    width: 5.072463768115942%;
  }
  .time {
    width: 12.318840579710145%;
    position: relative;
    .delay-timer {
      bottom: -0.2em;
    }
  }
  .patient {
    min-width: 34.057971014492754%;
    width: 30%;
  }
  .ap-type {
    text-align: center;
    width: 14.492753623188406%;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .note {
    text-align: left;
    width: 34.057971014492754%;
    padding: 0 1em;
  }
  .time-indicator {
    flex-wrap: wrap;
    min-height: initial;
    height: initial;
  }

  .paid {
    .ap-type {
      text-decoration: line-through;
    }
  }
`;

const TableRow = styled.tr`  
  background-color: ${p => p.active ? p.theme.color.veryLightBlue : p.theme.color.white}!important;
`;

//──── Check box ─────────────────────────────────────────────────────────────────────────

const checkBoxBorderColor = p => {
  let color = p.theme.color.border;
  if (p.checked || p.halfChecked) {
    color = p.theme.color.primary;
  }
  if (p.error) {
    color = p.theme.color.error;
  }
  return color;
};

const CheckBoxEl = styled.div`
  width: 18px;
  height: 18px;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  border: 1px solid;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-color: ${p => checkBoxBorderColor(p)};
  background-color: ${p => {
    if (p.checked || p.halfChecked) {
      return p.theme.color.primary;
    } if (p.disabled) {
      return p.theme.color.border;
    } else {
      return 'white';
    }
  }};
  pointer-events: ${p => p.disabled ? 'none' : 'auto'};
  background-position: center;
  background-repeat: no-repeat;
  background-size: 80%;
  ${p => { if (p.checked || p.disabled) return `background-image: url(${whiteCheckMark});`; }};
  ${p => p.halfChecked && `&:after{
    content: '';
    width: 10px;
    height: 2px;
    background-color: white;
    position: absolute;
    top: 45%;
    left: 3px;
    display: block;
  }`};
  &:hover{
    cursor: pointer;
    opacity: .8;
  }
`;


const EmptyBlock = styled.div`
  border-radius: 4px;
  border: solid 1px ${props => props.theme.color.border};  
  position: relative;
  text-align: center;
  height: calc(100vh - 62px - 60px - 62px - 80px - 4.5em);
  box-sizing: border-box;
  margin-top: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    p {
      font-size: 18px;
      color: ${p => p.theme.color.label};
      margin-top: 25px;
    }
  }
`;

export default {
  EmptyBlock,
  CheckBoxEl,
  Table,
  TableRow,
};